import { GetOrderSummaryParams } from '../../../services/modules/order/order.types';
import { getFindProductGridKey } from '../../../services/modules/product-grid/product-grid.keys';
import {
  FindProductGridOutput,
  GetFindProductGridKeyParams,
} from '../../../services/modules/product-grid/product-grid.types';
import { OrderHeadersGroupBy, OrderHeadersGroupByEnum } from '../products/orderProducts.types';
import { getGroupByInfo } from '../products/orderProducts.utils';
import {
  InvalidateAffectedOrderProductsGridQueriesParams,
  SyncSavedItemsIntoGridQueriesParams,
} from '../types/orderCalculate.utils.types';

export const getOrderCalculateUrlParams = (locationSearch: string) => {
  const searchParams = new URLSearchParams(locationSearch);

  let groupByList: OrderHeadersGroupBy[] = searchParams.getAll('GROUP_BY') as OrderHeadersGroupBy[];

  if (groupByList.length === 0) {
    groupByList = [OrderHeadersGroupByEnum.DEFAULT];
  }

  const groupByInfo = getGroupByInfo(searchParams.get('GROUP_BY_INFO'));

  const urlParams = new URLSearchParams();

  groupByList.forEach((groupBy) => {
    urlParams.append('headerType', groupBy);
  });
  if (groupByList?.length === 1) {
    urlParams.append('headerType', OrderHeadersGroupByEnum.DEFAULT);
  }

  const classificationTypeIds = Array.isArray(groupByInfo?.classificationTypeId)
    ? groupByInfo.classificationTypeId
    : groupByInfo?.classificationTypeId
      ? [groupByInfo.classificationTypeId]
      : [];

  // TODO: ESSE FLUXO TODO TA MEIO CONFUSO, TEMOS QUE REFATORAR... HORA ADICIONAR UM DEFAULT EM ALGO QUE É PARA SER ID, TEM CONDIÇÕES TERNARIAS ANINHADAS... TA COMPLICADO
  classificationTypeIds.forEach((id) => {
    urlParams.append('classificationTypeId', id);
  });

  if (classificationTypeIds.length == 1) {
    urlParams.append('classificationTypeId', OrderHeadersGroupByEnum.DEFAULT);
  }

  const typedParams: NonNullable<GetOrderSummaryParams['typedParams']> = {
    headerType: groupByList,
    classificationTypeId: classificationTypeIds,
  };

  return {
    urlParams,
    typedParams,
  };
};

export const invalidateAffectedOrderProductsGridQueries = ({
  teamId,
  orderId,
  queryClient,
  isOfflineMode,
  affectedOrderProducts,
}: InvalidateAffectedOrderProductsGridQueriesParams) => {
  affectedOrderProducts.forEach((item) => {
    const paramsToFindGridQueryKey: GetFindProductGridKeyParams = {
      orderId,
      isOfflineMode,
      availability: item.availability,
      productColorId: item.productColorId,
      deliveryWindowId: item.deliveryWindowId ?? null,
    };

    const gridQueryKey = getFindProductGridKey(paramsToFindGridQueryKey);

    queryClient.invalidateQueries({
      stale: true,
      queryKey: [teamId, ...gridQueryKey],
    });

    queryClient.removeQueries({ type: 'inactive', queryKey: [teamId, ...gridQueryKey] });
  });
};

export const syncSavedItemsIntoGridQueries = ({
  teamId,
  queryClient,
  savedItems,
  isOfflineMode = false,
}: SyncSavedItemsIntoGridQueriesParams) => {
  savedItems.forEach((savedItem) => {
    const gridQueryKey = getFindProductGridKey({
      isOfflineMode,
      orderId: savedItem.orderId,
      availability: savedItem.availability,
      productColorId: savedItem.productColorId,
      deliveryWindowId: savedItem.deliveryWindowId ?? null,
    });

    queryClient.setQueryData<FindProductGridOutput>([teamId, ...gridQueryKey], (cached) => {
      if (!cached) {
        return cached;
      }

      return {
        ...cached,
        grid: cached.grid.map((cachedItem) =>
          cachedItem.skuId === savedItem.skuId
            ? {
                ...cachedItem,
                orderItemId: savedItem.orderItemId,
                orderItemQuantity: savedItem.orderItemQuantity,
              }
            : cachedItem,
        ),
      };
    });
  });
};
